module.exports = __webpack_public_path__ + "static/media/loading.9da4a7aa.gif";